import React, { RefObject } from 'react'
import { Card, RenderControl, IRenderControl, Table, Flex } from '@fareye/ui'
import { getTableColumns } from '../components/ChildFilterColumn/Column'
import { Header } from '../components/Header'
import { Columns } from '../../../config/constants'
import { useTranslation } from '@fareye/common'

interface IDataListing {
  selectedColumns: Array<string>
  apiData: IRenderControl
  label: string
  setSelectedDataForEdit: (data: any) => void
  containerRef: RefObject<HTMLDivElement>
  history?:any
}

export function DataListing({
  selectedColumns,
  setSelectedDataForEdit,
  apiData,
  label,
  containerRef,
  history
}: IDataListing) {
  const { data } = apiData
  const [tableData, setTableData] = React.useState<Array<any>>(data)
  const [searchData, setSearchData] = React.useState('')
  const { t } = useTranslation()
  React.useEffect(() => {
    if (searchData) {
      filterChildUserAndFilterData(searchData)
    } else {
      setTableData(data)
    }
  }, [searchData, data])

  const NoData = () => (
    <Flex m={1} justifyContentCenter>
      No Data Found for this Search...
    </Flex>
  )

  function filterChildUserAndFilterData(searchText: string = '') {
    const filteredData = tableData.filter(ele => {
      return Columns.some(col => {
        if (ele[col.key] && col.key !== 'action') {
          return ele[col.key].toLowerCase().includes(searchText.toLowerCase())
        }
      })
    })
    setTableData(filteredData)
  }

  return (
    <Card
      bg="#fff"
      variant="s"
      header={<Header setTextData={setSearchData} label={label} />}
    >
      <RenderControl state={apiData} variant="s">
        <Table
          data={tableData}
          columns={getTableColumns(selectedColumns, {
            t,
            setSelectedDataForEdit,
            containerRef,
            history
          })}
          totalElements={tableData.length}
          className="responsive striped"
          // getTrProps={(_: any, { index }: any) => {
          //   return {
          //     style: {
          //       backgroundColor: `${index % 2 == 1 ? '#e6eff4' : '#FFFFFF'}` // TODO className striped instead this line
          //     }
          //   }
          // }}
          // minRows={0}
          // NoDataComponent={NoData}
        />
      </RenderControl>
    </Card>
  )
}
